/* import __COLOCATED_TEMPLATE__ from './prism-tooltip-bubble.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  classNames: ['prism-tooltip-bubble'],
  classNameBindings: ['isLeft:prism-tooltip-bubble--left:prism-tooltip-bubble--right', 'isShowing::prism-tooltip-bubble--hide'],
  isShowing: true,
  isLeft: true,
  onExternalClick() {}
});